export default __webpack_public_path__ + "static/media/58t.35319670.jpg";